/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseCreatedEvent = {
  type: "response.created";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseCreatedEvent$inboundSchema: z.ZodType<
  ResponseCreatedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.created"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseCreatedEvent$Outbound = {
  type: "response.created";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseCreatedEvent$outboundSchema: z.ZodType<
  ResponseCreatedEvent$Outbound,
  z.ZodTypeDef,
  ResponseCreatedEvent
> = z.object({
  type: z.literal("response.created"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseCreatedEventToJSON(
  responseCreatedEvent: ResponseCreatedEvent,
): string {
  return JSON.stringify(
    ResponseCreatedEvent$outboundSchema.parse(responseCreatedEvent),
  );
}
export function responseCreatedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseCreatedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseCreatedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseCreatedEvent' from JSON`,
  );
}
